var seek = kendo.data.transports.seek = kendo.data.RemoteTransport.extend({});
export default seek;